<h2 mat-dialog-title>
    Gerir contas {{ pos.pos?.name }}
</h2>
<div class="w" mat-dialog-content>

    <div class="payment-entry-wrapper">
        <div class="cenas">
            <div class="payment-entry-core" *ngFor="let order of orders; let i = index">

                <div class="payment-entry">
                    <input #inputField (blur)="calculateValues()" matInput
                           [disabled]="order.name === 'Conta Geral' || loading"
                           [(ngModel)]="order.name"
                           (keydown.enter)="calculateValues()"
                           placeholder="Nome da conta"/>
                </div>
                <button color="warn" class="validate-btn" mat-icon-button
                        [disabled]="isOnlyContaGeral(order) || loading"
                        (click)="removeOrder(i)">
                    <mat-icon [svgIcon]="'heroicons_outline:x'"></mat-icon>
                </button>
                <button color="primary" class="validate-btn" mat-icon-button (click)="saveOrder(order)"
                        [disabled]="!isAccountModified(order, i) || loading">
                    <mat-icon svgIcon="mat_outline:save"></mat-icon>
                </button>
            </div>
            <div style="display: flex; justify-content: center; margin-top: 20px">
                <button mat-flat-button color="primary" [disabled]="loading" (click)="addAccount()">
                    <mat-icon [svgIcon]="'heroicons_outline:plus'"></mat-icon>
                    Adicionar conta
                </button>
            </div>
        </div>
    </div>
</div>
